export const resultHandlers = (onSucess, onError) => res => res.status === 200 ? res.json().then(onSucess) : [onError(res)]
export const resultHandler = (onSucess, onError) => res => res.status === 200 ? res.json().then(onSucess) : onError(res)
